import { useRef, } from 'react'
import {
  View,
  Text,
  TextInput,
  ActivityIndicator
} from 'react-native'
import { KeyboardAwareScrollView } from 'react-native-keyboard-aware-scroll-view'
import { globalStyles } from '../../../static/styles/global'
import HomeDetailsHeader from '../../home/HomeDetailsHeader'
import Card from '../../shared/card/Card'
import CustomButton from '../../shared/button/Button'
import { Formik } from 'formik'
import * as yup from 'yup'
import { useFormsStore } from '../../../stores/onboarding'
import { useInitializeStore } from '../../../stores/initialize'
import SelectKeyValue from '../../shared/form/SelectKeyValue'
import { mapSelectValue } from '../../../utils'
import { usePersonalStore } from '../../../stores/personalInfo'
import Toast from 'react-native-toast-message'

const OrInformationForm = ({ navigation, route }) => {
  const formikRef = useRef(null)
  const { params } = route
  const {
    mostRecentUserOnBoardings: userId,
    mode,
    essUserOnBoardingKey,
    essUserOnBoardingFormKey,
  } = params
  const intializeStore = useInitializeStore()
  const { postoronline, loading } = useFormsStore()


  const personalstore = usePersonalStore()

  const options1 = [
    { key: 1, value: 'No' },
    { key: 2, value: 'Yes' }
  ]
  const options2 = [
    { key: 1, value: 'Single' },
    { key: 2, value: 'Married' },
    { key: 3, value: 'Married, but withhold at the higher single rate' }
  ]

  const intialValues = {
    redetermination: '',
    filingstatus: '',
    additionalamount: '',
    exemptioncode: '',
    exempt: '',
    allowances: ''
  }


  const w4schema = () => {
    const baseSchema = {
      redetermination: yup
        .string()
        .nullable(),
      filingstatus: yup.string().required('Filing Status is a required field'),
      additionalamount: yup.string().nullable(),
      // exempt: yup.string().nullable(),
      exempt: yup.string()
        .matches(/^exempt$/i, "Enter 'Exempt' or leave it empty")
        .nullable(),
      exemptioncode: yup.string().nullable(),
      allowances: yup.string().nullable()
    }
    return yup.object(baseSchema)
  }
  const schema = w4schema()

  return (
    <KeyboardAwareScrollView
      enableOnAndroid={true}
      enableAutomaticScroll={true}
      enableResetScrollToCoords={false}
      keyboardShouldPersistTaps="handled"
      keyboardDismissMode="interactive"
      showsVerticalScrollIndicator={false}
      extraScrollHeight={80}
      contentContainerStyle={{ flexGrow: 1, paddingBottom: 20 }}
    >
      <View style={[globalStyles.primaryBgColor, globalStyles.containerBand]}>
        <View style={[globalStyles.horizontalPadGap]}>
          <HomeDetailsHeader
            navLabel="Forms"
            navScreen="OnboardingForms"
            title={'OR Withholding'}
          />
        </View>
      </View>
      <View style={globalStyles.containerOverlap}>
        <Formik
          initialValues={{ ...intialValues }}
          validationSchema={schema}
          onSubmit={async (values, actions) => {
            const data = {
              entityId: personalstore?.personalData?.entityId,
              essUserKey: intializeStore?.initializeData?.userkey,
              essObKey: essUserOnBoardingKey,
              essUserOnBoardingFormKey: essUserOnBoardingFormKey,
              completeOnline: mode === 'upload' ? false : true,
              reDetermination: values?.redetermination ? values?.redetermination : null,
              filingStatus: values?.filingstatus,
              allowances: values?.allowances ? values?.allowances : null,
              additionalAmount: values?.additionalamount ? values?.additionalamount : null,
              exemptionCode: values?.exemptioncode,
              exempt: values?.exempt,

            }
            const response = await postoronline(data)

            if (response?.success) {
              if (mode === 'online') {
                navigation.navigate('OrInformationOnline', {
                  userId,
                  mode,
                  essUserOnBoardingKey,
                  essUserOnBoardingFormKey,
                  values,
                })
              } else {
                await Toast.show({
                  type: 'success',
                  position: 'bottom',
                  text1: response?.message,
                  visibilityTime: 3000,
                  autoHide: true,
                  topOffset: 60,
                  onHide: () => {
                    navigation.replace('OnboardingForms')
                  }
                })
              }
            } else {
              await Toast.show({
                type: 'error',
                position: 'bottom',
                text1: response?.message,
                visibilityTime: 3000,
                autoHide: true,
                topOffset: 60
              })
            }

          }}
        >
          {(props) => (
            <>
              <Card>
                <View
                  style={[
                    globalStyles.hDirection,
                    globalStyles.hBetweenItems,
                    globalStyles.mb2
                  ]}
                >
                  <View style={{ justifyContent: 'center', width: '65%' }}>
                    <Text
                      style={[
                        globalStyles.inputLabel,
                        globalStyles.inputLabelLarge,
                        globalStyles.inputLabelPrimary
                      ]}
                    >
                      {
                        'Filing Status (Select “Single” if you’re married but legally separated or your spouse is a non-U.S. citizen without permanent resident status)*'
                      }
                    </Text>
                  </View>
                  <View style={{ width: '30%', overflow: 'hidden' }}>
                    <SelectKeyValue
                      title="Filing Status (Select “Single” if you’re married but legally separated or your spouse is a non-U.S. citizen without permanent resident status)"
                      options={options2}
                      selectedOption={mapSelectValue(
                        options2,
                        props.values.filingstatus
                      )}
                      onSelect={(option: any) => {
                        props.setFieldValue('filingstatus', option - 1)
                      }}
                      textColor="primary"
                    />
                    {props.touched.filingstatus &&
                      props.errors.filingstatus && (
                        <Text style={globalStyles.dangerAlert}>
                          {props.errors.filingstatus}
                        </Text>
                      )}
                  </View>
                </View>
                <View
                  style={[
                    globalStyles.hDirection,
                    globalStyles.hBetweenItems,
                    globalStyles.mb2
                  ]}
                >
                  <View style={{ width: '65%', justifyContent: 'center' }}>
                    <Text
                      style={[
                        globalStyles.inputLabel,
                        globalStyles.inputLabelLarge,
                        globalStyles.inputLabelPrimary
                      ]}
                    >
                      {
                        'Allowances. Total number of allowances you’re claiming on line A4, B15, or C5'
                      }
                    </Text>
                  </View>
                  <View style={{ width: '30%', overflow: 'hidden' }}>
                    <TextInput
                      style={[globalStyles.input, globalStyles.inputLight]}
                      value={props.values.allowances}
                      keyboardType="numeric"
                      onChangeText={(text) => {
                        if (text === '' || /^\d+$/.test(text)) {
                          props.handleChange('allowances')(text)
                        }
                      }}
                    />
                    {props.touched.allowances &&
                      props.errors.allowances && (
                        <Text style={globalStyles.dangerAlert}>
                          {props.errors.allowances}
                        </Text>
                      )}
                  </View>
                </View>

                {props.values.exempt?.toLowerCase() !== 'exempt' && (
                  <View
                    style={[
                      globalStyles.hDirection,
                      globalStyles.hBetweenItems,
                      globalStyles.mb2
                    ]}
                  >
                    <View style={{ width: '65%', justifyContent: 'center' }}>
                      <Text
                        style={[
                          globalStyles.inputLabel,
                          globalStyles.inputLabelLarge,
                          globalStyles.inputLabelPrimary
                        ]}
                      >
                        {
                          'Additional amount, if any, you want withheld from each paycheck'
                        }
                      </Text>
                    </View>
                    <View style={{ width: '30%', overflow: 'hidden' }}>
                      <TextInput
                        style={[globalStyles.input, globalStyles.inputLight]}
                        value={props.values.additionalamount}
                        keyboardType="numeric"
                        onChangeText={(text) => {
                          if (text === '' || /^\d+$/.test(text)) {
                            props.handleChange('additionalamount')(text)
                          }
                        }}
                      />
                      {props.touched.additionalamount &&
                        props.errors.additionalamount && (
                          <Text style={globalStyles.dangerAlert}>
                            {props.errors.additionalamount}
                          </Text>
                        )}
                    </View>
                  </View>
                )}

                <View
                  style={[
                    globalStyles.hDirection,
                    globalStyles.hBetweenItems,
                    globalStyles.mb2
                  ]}
                >
                  <View style={{ width: '65%', justifyContent: 'center' }}>
                    <Text
                      style={[
                        globalStyles.inputLabel,
                        globalStyles.inputLabelLarge,
                        globalStyles.inputLabelPrimary
                      ]}
                    >
                      {
                        'Enter your exemption code if applicable'
                      }
                    </Text>
                  </View>
                  <View style={{ width: '30%', overflow: 'hidden' }}>
                    <TextInput
                      style={[globalStyles.input, globalStyles.inputLight]}
                      value={props.values.exemptioncode}
                      onChangeText={(text) => {

                        props.handleChange('exemptioncode')(text)

                      }}
                    />
                    {props.touched.exemptioncode &&
                      props.errors.exemptioncode && (
                        <Text style={globalStyles.dangerAlert}>
                          {props.errors.exemptioncode}
                        </Text>
                      )}
                  </View>
                </View>

                {/* <View
                  style={[
                    globalStyles.hDirection,
                    globalStyles.hBetweenItems,
                    globalStyles.mb2
                  ]}
                >
                  <View style={{ justifyContent: 'center', width: '65%' }}>
                    <Text
                      style={[
                        globalStyles.inputLabel,
                        globalStyles.inputLabelLarge,
                        globalStyles.inputLabelPrimary
                      ]}
                    >
                      {'Exempt'}
                    </Text>
                  </View>
                  <View style={{ width: '30%', overflow: 'hidden' }}>
                    <SelectKeyValue
                      title="Exempt"
                      options={options1}
                      selectedOption={mapSelectValue(
                        options1,
                        props.values.exempt
                      )}
                      onSelect={(option: any) => {
                        if (option == 2) {
                          props.setFieldValue('exempt', 'Exempt')
                        } else { props.setFieldValue('exempt', 'No') }

                      }}
                      textColor="primary"
                    />
                    {props.touched.exempt &&
                      props.errors.exempt && (
                        <Text style={globalStyles.dangerAlert}>
                          {props.errors.exempt}
                        </Text>
                      )}
                  </View>
                </View> */}


                <View
                  style={[
                    globalStyles.hDirection,
                    globalStyles.hBetweenItems,
                    globalStyles.mb2
                  ]}
                >
                  <View style={{ width: '65%', justifyContent: 'center' }}>
                    <Text
                      style={[
                        globalStyles.inputLabel,
                        globalStyles.inputLabelLarge,
                        globalStyles.inputLabelPrimary
                      ]}
                    >
                      {
                        `Enter “Exempt”`
                      }
                    </Text>
                  </View>
                  <View style={{ width: '30%', overflow: 'hidden' }}>
                    <TextInput
                      style={[globalStyles.input, globalStyles.inputLight]}
                      value={props.values.exempt}
                      onChangeText={(text) => {
                        props.handleChange('exempt')(text)
                        if (text?.toLowerCase() === 'exempt') {
                          props.setFieldValue('additionalamount', '')
                        }
                      }}
                    />
                    {props.touched.exempt &&
                      props.errors.exempt && (
                        <Text style={globalStyles.dangerAlert}>
                          {props.errors.exempt}
                        </Text>
                      )}
                  </View>
                </View>


                <View
                  style={[
                    globalStyles.hDirection,
                    globalStyles.hBetweenItems,
                    globalStyles.mb2
                  ]}
                >
                  <View style={{ justifyContent: 'center', width: '65%' }}>
                    <Text
                      style={[
                        globalStyles.inputLabel,
                        globalStyles.inputLabelLarge,
                        globalStyles.inputLabelPrimary
                      ]}
                    >
                      {'Redetermination'}
                    </Text>
                  </View>
                  <View style={{ width: '30%', overflow: 'hidden' }}>
                    <SelectKeyValue
                      title="Redetermination"
                      options={options1}
                      selectedOption={mapSelectValue(
                        options1,
                        props.values.redetermination
                      )}
                      onSelect={(option: any) => {
                        props.setFieldValue('redetermination', option - 1)
                      }}
                      textColor="primary"
                    />
                    {props.touched.redetermination &&
                      props.errors.redetermination && (
                        <Text style={globalStyles.dangerAlert}>
                          {props.errors.redetermination}
                        </Text>
                      )}
                  </View>
                </View>


                {loading ? (
                  <ActivityIndicator />
                ) : (
                  <View style={{ margin: 10 }}>
                    <CustomButton
                      text={mode === 'upload' ? 'Submit Information' : 'Next'}
                      onPress={props.handleSubmit}
                    />
                  </View>
                )}
              </Card>
            </>
          )}
        </Formik>
      </View>

    </KeyboardAwareScrollView>
  )
}

export default OrInformationForm